(function() {
	'use strict';
	var $ = avm.require('cash'),
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$secondaryNav = $('#secondary-nav-row'),
		$media1waypoint = $('#privacy-media'),
		$media2waypoint = $('#media2-anchor'),
		$media3waypoint = $('#media3-anchor'),
		$media4waypoint = $('#media4-anchor'),
		$media5waypoint = $('#media5-anchor'),
		$testimonialsWaypoint = $('#testimonials'),
		$navLinks = $('.nav-link'),
		$open = $('.js-open'),
		$close = $('.js-close'),
		setActive = function($this) {
			$navLinks.removeClass('active');
			$this.addClass('active');
		},
		navItemsActivation = function() {
			if (waypoints($media1waypoint, null, null, true)) { setActive($('#nav-link1')); }
			if (waypoints($media2waypoint, null, null, true)) { setActive($('#nav-link2')); }
			if (waypoints($media3waypoint, null, null, true)) { setActive($('#nav-link3')); }
			if (waypoints($media4waypoint, null, null, true)) { setActive($('#nav-link4')); }
			if (waypoints($media5waypoint, null, null, true)) { setActive($('#nav-link5')); }
		};

	$window.on('resize scroll', navItemsActivation);

	//Secondary navigation: Sticky navigation
	$window.on('resize scroll', function() {
		if (waypoints($media1waypoint, null, null, true)) {
			$secondaryNav.addClass('is-sticky');
		} else {
			$secondaryNav.removeClass('is-sticky');
			$navLinks.removeClass('active');
		}

		if (waypoints($testimonialsWaypoint, null, null, true)) {
			$secondaryNav.addClass('hidden');
		} else {
			$secondaryNav.removeClass('hidden');
		}
	});

	// Expand/collapse features on 2nd media oject
	$open.on('click', function() {
		var $target = $(this).parents('section').next('section');
		$target.addClass('show');
		$(this).addClass('hidden');
	});

	$close.on('click', function() {
		var $target = $(this).parents('section'),
			$openButton = $target.prev('section').find('.js-open');

		$openButton.removeClass('hidden');
		$target.removeClass('show');
	});
})();
